import { H5, Image, LI } from "../../../../AbstractElements";
import { ImagesAssets } from "../../../../Component/shared/ImageAssets";
import { dynamicImage } from "../../../../Service";
import UseOutsideDropdown from "../../../../utils/UseOutsideDropdown";
import UserProfileIcons from "./UserProfileIcons";

const UserProfile = () => {
  const { ref, isComponentVisible, setIsComponentVisible } =
    UseOutsideDropdown(false);
  const userDetail = JSON.parse(localStorage.getItem("Profile") || "{}");

  return (
    <LI
      style={{
        cursor: "pointer",
      }}
      className="profile-dropdown custom-dropdown"
    >
      <div
        ref={ref}
        className="d-flex align-items-center"
        onClick={() => setIsComponentVisible(!isComponentVisible)}
      >
        <Image
          src={ImagesAssets.USER}
          alt="avatar"
          style={{ width: 65, height: 50 }}
        />
        <div className="flex-grow-1">
          <H5>{userDetail.first_name || "" + userDetail.last_name || ""}</H5>
          <span>{userDetail.Designations.Designation || ""}</span>
        </div>
      </div>
      <div
        className={`custom-menu overflow-hidden ${
          isComponentVisible ? "show" : ""
        }`}
      >
        <UserProfileIcons />
      </div>
    </LI>
  );
};

export default UserProfile;
